/** The browser's IANA time zone, which the scheduler uses to find day boundaries. */
export function currentTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
